import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { isMac } from "./lib/utils";
import { applyLaunchRoute } from "./features/navigation/launch";

if (window.deskBridge) document.documentElement.classList.add("is-electron");
if (isMac) document.documentElement.classList.add("is-mac");

applyLaunchRoute();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
